export default "__VITE_ASSET__DK_vPTkB__"